import React from 'react';
import { Link } from 'react-router-dom';
import { footerData } from '../data/pageData';
import { siteInfoData } from '../data/navItems';
import SocialIcon from './common/SocialIcon';

const Footer = () => {
    const data = footerData;
    return (
        <footer className="bg-gray-800 text-gray-300 py-16">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                 <div className="bg-gray-700 p-8 md:p-10 rounded-xl shadow-2xl mb-16 transform  transition-transform duration-500">
                    <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-white text-center lg:text-left">{data.subscriptionTitle}</h3>
                        <form className="flex w-full lg:w-1/2 max-w-full">
                            <input type="email" placeholder="Enter your email address" className="px-3 sm:px-5 py-3 rounded-l-md focus:outline-none focus:ring-2 focus:ring-yellow-500 text-gray-800 flex-grow text-sm min-w-0" />
                            <button type="submit" className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 sm:px-6 py-3 rounded-r-md font-semibold text-sm transition-colors duration-300 transform hover:scale-105 whitespace-nowrap">Subscribe</button>
                        </form>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                    <div>
                        <h5 className="text-xl font-bold text-white mb-6">{data.quickLinks.title}</h5>
                        <ul className="space-y-3 text-sm">
                            {data.quickLinks.links.map(link => (
                                <li key={link.name}>
                                    {link.page === "#" ? (
                                        <a href="#" className="hover:text-yellow-400 transition-colors duration-300">{link.name}</a>
                                    ) : (
                                        <Link to={`/${link.page === 'home' ? '' : link.page}`} className="hover:text-yellow-400 transition-colors duration-300">{link.name}</Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h5 className="text-xl font-bold text-white mb-6">{data.otherPages.title}</h5>
                        <ul className="space-y-3 text-sm">
                             {data.otherPages.links.map(link => (
                                <li key={link.name}>
                                    {link.page === "#" ? (
                                        <a href="#" className="hover:text-yellow-400 transition-colors duration-300">{link.name}</a>
                                    ) : (
                                        <Link to={`/${link.page === 'home' ? '' : link.page}`} className="hover:text-yellow-400 transition-colors duration-300">{link.name}</Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <h5 className="text-xl font-bold text-white mb-6">{data.contactInfo.title}</h5>
                        <ul className="space-y-3 text-sm">
                            <li><p className="leading-relaxed">{data.contactInfo.address}</p></li>
                            <li><p>📞 {data.contactInfo.phone}</p></li>
                            <li><p>✉️ {data.contactInfo.email}</p></li>
                            <li><p>🕒 {data.contactInfo.hours}</p></li>
                        </ul>
                    </div>
                    <div>
                        <h5 className="text-xl font-bold text-white mb-6">{data.appointment.title}</h5>
                        <p className="text-sm mb-4 leading-relaxed">{data.appointment.text}</p>
                        <Link to={`/${data.appointment.buttonLink === 'home' ? '' : data.appointment.buttonLink}`} className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-6 py-3 rounded-md text-sm shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105">
                            {data.appointment.buttonText}
                        </Link>
                    </div>
                </div>
                <div className="mt-16 border-t border-gray-700 pt-10 flex flex-col sm:flex-row justify-between items-center text-sm">
                    <p>&copy; {new Date().getFullYear()} {data.copyrightText}</p>
                    <div className="flex items-center space-x-3 mt-6 sm:mt-0">
                        {siteInfoData.socialLinks.map(social => (
                            <SocialIcon key={social.name} char={social.char} url={social.url} />
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;